import React, { useState } from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
function Dip({
  selection,
  setSelection,
  unSelectedNumbers,
  selectedNumbers,
  unSelectedSelection,
  selectedSelection,
  setUnSelectedNumbers,
  setSelectedNumbers,
  setUnSelectedSelection,
  setSelectedSelection,
  defaultValues
}) {
  const move = arrow => {
    if (arrow == 'right') {
      let newNums = [...selectedNumbers, ...unSelectedSelection];
      setSelectedNumbers(newNums);
      let newArr = unSelectedNumbers.filter(num => !unSelectedSelection.includes(num));
      setUnSelectedNumbers(newArr);
    } else {
      let newNumbers = [...unSelectedNumbers, ...selectedSelection];
      setUnSelectedNumbers(newNumbers);
      let newArr = selectedNumbers.filter(num => !selectedSelection.includes(num));
      setSelectedNumbers(newArr);
    }
    setUnSelectedSelection([]);
    setSelectedSelection([]);
  };
  return (
    <div className="p-4">
      <Row>
        <Col md={2}>
          <Label>
            <Input
              onChange={e => setSelection('all')}
              checked={selection === 'all'}
              type="checkbox"
            />{' '}
            Apply Default
          </Label>
        </Col>
        <Col md={4}>
          <Label>
            <Input
              type="checkbox"
              onChange={e => setSelection('selection')}
              checked={selection === 'selection'}
            />{' '}
            Select Telephone Numbers
          </Label>
        </Col>
      </Row>
      {selection === 'selection' && (
        <>
          <h2>
            Select numbers to enable inbound caller name delivery (CNAM Dips) for inbound calls
          </h2>
          <p>
            In box below, click to select Telephone Numbers targeted by data above.
            <br />
            To multi-select, click and drag across numbers, or use Shift or Ctrl
          </p>
          <Row>
            <Col md={6}>
              <div className="d-flex justify-content-between align-items-center w-100">
                <select
                  value={unSelectedSelection}
                  id="unSelectedNumbers"
                  onChange={e =>
                    setUnSelectedSelection(
                      Object.values(e.target.selectedOptions).map(item => item.value),
                    )
                  }
                  multiple={true}
                  style={{ width: '40%', height: 100 }}
                >
                  {unSelectedNumbers.map(number => (
                    <option key={number} value={number} label={number} />
                  ))}
                </select>
                <div>
                  <div onClick={() => move('right')} className="arrow-icon">
                    <i className="fas fa-long-arrow-alt-right" />
                  </div>
                  <div onClick={() => move('left')} className="arrow-icon">
                    <i className="fas fa-long-arrow-alt-left" />
                  </div>
                </div>
                <select
                  value={selectedSelection}
                  id="unSelectedNumbers"
                  onChange={e =>
                    setSelectedSelection(
                      Object.values(e.target.selectedOptions).map(item => item.value),
                    )
                  }
                  multiple={true}
                  style={{ width: '40%', height: 100 }}
                >
                  {selectedNumbers.map(number => (
                    <option key={number} value={number} label={number} />
                  ))}
                </select>
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default Dip;
